DELEGATES_TO_SYMBOL